module.exports = __webpack_public_path__ + "static/media/img-maincon.eedbf347.png";